export default __webpack_public_path__ + "static/hero-be6df6190f60423e17004d583ee14a83.png";